import { render } from "./ProfileMain.vue?vue&type=template&id=65239f46&scoped=true"
import script from "./ProfileMain.vue?vue&type=script&lang=js"
export * from "./ProfileMain.vue?vue&type=script&lang=js"

import "./ProfileMain.vue?vue&type=style&index=0&id=65239f46&lang=scss&scoped=true"

import exportComponent from "/Users/Shared/PLAYLANE/Execution/P1901021/sandpiper/bbud-server/teacher-platform-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-65239f46"]])

export default __exports__